import { PhoneValidator } from './phone.validator';

export const FormValidators = {
    Phone: PhoneValidator,
};
